export const tzMoscow = 'Europe/Moscow';
